import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import { isEditCandidateModalOpenState } from "../../../../recoil/admin/examRoom";
import CandidateEditModal from "./CandidateEditModal";
import { testRoomSnState } from "recoil/auth";
import useDebounceValue from "../../../../api/hooks/debounce";
import SendMailModal from "./SendMailModal";
import { dateFormat } from "../../../../utils";
import Table from "../../../modules/layout/Table";
import Banner from "../../../modules/layout/Banner";
import ResultCheckModal from "./ResultCheckModal";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { alignState } from "../../../../static";
import Select from "../../../atoms/input/Select";
import { EXAMSTATE } from "../../../../submodules/enum/exam";
import ResultLogModal from "./ResultLogModal";
import Xlsx from "../../../../api/hooks/xlsx";
import { isTestroomNameState } from "../../../../recoil/admin/examRoom";
import DeleteConfirmModal from "./DeleteConfirmModal";
// 관리자-시험실-응시자탭

const CandidateTab = () => {
  const setEditCandidateModalOpen = useSetRecoilState(
    isEditCandidateModalOpenState
  );
  const [isResultCheckModalOpen, setIsResultCheckModalOpen] = useState(false);
  const { fetchCandidataList } = useExamRoomActions();
  const [mailUserSn, setMailUserSn] = useState(0);
  const [resultUserSn, setResultUserSn] = useState(0);
  const isTestRoomSn = useRecoilValue(testRoomSnState);
  const [searchKeyword, setSearchKeyword] = useState("");
  const debouncedSearchKeyword = useDebounceValue(searchKeyword);
  const testroomName = useRecoilValue(isTestroomNameState);
  const [deleteUserSn, setDeleteUserSn] = useState(0);

  // 유저 state
  const [selectedCandidate, setSelectedCandidate] = useState({});

  const { getRoomCnt } = useExamRoomActions();
  const { data: roomCnt } = useQuery({
    queryKey: ["getRoomCnt", isTestRoomSn],
    queryFn: () => getRoomCnt({ room_sn: isTestRoomSn }),
  });

  const [sendAlignState, setSendAlignState] = useState("1");
  const {
    data: candidataListData,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: [
      "fetchCandidateList",
      isTestRoomSn,
      debouncedSearchKeyword,
      sendAlignState,
    ],
    queryFn: () =>
      fetchCandidataList({
        keyword: debouncedSearchKeyword,
        room_sn: isTestRoomSn,
        orderType: sendAlignState,
      }),
  });

  // 버튼 이벤트
  const openEditCandidateModal = (candidate) => {
    setSelectedCandidate(candidate);
    setEditCandidateModalOpen(true);
  };


  const avgCalculation = (finish_tester, apply_tester) => {
    if (apply_tester === 0) {
      return "0%";
    } else {
      return String(((finish_tester / apply_tester) * 100).toFixed(0)) + "%";
    }
  };
  const { getXlsxDownloadHref } = Xlsx();

  return (
    <div className="tab-content">
      <div className="tab-pane">
        <Banner
          properties={["시험요청", "응시대기", "응시완료", "응시중단"]}
          data={[
            roomCnt?.data?.applicator,
            roomCnt?.data?.testring,
            roomCnt?.data?.done,
            candidataListData?.data?.abortment_opic_tester,
          ]}
          icons={["request", "wait", "complete", "stop"]}
        />
        <div className="flex filtering">
          <div>
            <button
              className="btn-custom w-btn exel-icon-b"
              onClick={() => {
                getXlsxDownloadHref(
                  isTestRoomSn,
                  testroomName + "_응시현황_" + dayjs().format("YYYYMMDD")
                );
              }}
            >
              응시현황(Excel)
            </button>
          </div>
          <div>
            <div className="dropdown content1-dropdown">
              <Select
                options={alignState}
                onChange={(e) => {
                  setSendAlignState(e.target.value);
                }}
              ></Select>
              {/* <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="#">
                    시험요청순
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    응시완료순
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    이름순
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    수험번호순
                  </a>
                </li>
              </ul> */}
            </div>
            <input
              type="text"
              className="search-input"
              placeholder="이름, 이메일, 시험코드"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
            {/* <button
              className="btn-custom b-btn input-btn"
              onClick={() => refetch()}
            >
              검색
            </button> */}
          </div>
        </div>
        <div className="tableFixHead table-responsive">
          <div className="overflow-scroll height-300">
            <Table
              isLoading={isLoading}
              className="roomtable-content1"
              header={[
                "No.",
                "이름(시험코드)",
                "응시문항",
                "사진/스냅샷",
                "코드발송이력",
                "응시현황",
                "응시로그",
                "응시결과",
                "평가자",
                "작업",
              ]}
            >
              {candidataListData?.data?.map((candidate, index) => (
                // <tr key={candidate?.sn}>
                <tr key={index}>
                  <td>{candidate?.sn}</td>
                  <td>
                    <button
                      type="button"
                      // className="txt-modalbtn user-info-modalbtn"
                      // data-bs-toggle="modal"
                      // data-bs-target="#user-info"
                      // onClick={() => {
                      //   openEditCandidateModal(candidate);
                      // }}
                    >
                      {candidate?.name}
                    </button>
                    <br />
                    {candidate.tester_code}
                  </td>
                  <td>
                    <button
                      type="button"
                      // className="txt-modalbtn questions-modalbtn"
                      // data-bs-toggle="modal"
                      // data-bs-target="#questions"
                    >
                      배정완료
                    </button>
                  </td>
                  <td>
                    {/*<img*/}
                    {/*  src={candidate?.image}*/}
                    {/*  alt="사진/스냅샷"*/}
                    {/*  className="snapshot"*/}
                    {/*/>*/}
                    <span>미등록</span>
                  </td>
                  <td>
                    {candidate?.sms_date}
                    <button type="button" className="message-modalbtn"></button>
                    <br />
                    {/* {dateFormat(candidate?.code_email_sendtime)} */}
                    {dayjs(candidate?.code_email_sendtime).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
                    <button
                      type="button"
                      className="mail-modalbtn"
                      onClick={() => {
                        setMailUserSn(candidate.applicator_sn);
                        setTimeout(() => {
                          setMailUserSn(0);
                        }, 100);
                      }}
                    ></button>
                  </td>
                  <td>
                    <div
                      className="text-align-left status-text"
                      style={{ display: "inline-block", margin: 10 }}
                    >
                      {/* {candidate.tester_state ? (
                        <span>
                          완료 <br />
                          {dateFormat(candidate?.tester_finish_time)}
                        </span>
                      ) : (
                        <span>미응시</span>
                      )} */}
                      {candidate.tester_state >= EXAMSTATE.DONE && (
                        <span>
                          완료 <br />
                          {dateFormat(candidate?.tester_finish_time)}
                        </span>
                      )}
                      {candidate.tester_state < EXAMSTATE.DONE && (
                        <span>응시대기</span>
                      )}
                    </div>
                    <div style={{ display: "inline-block" }}>
                      {/* 중단 완료 기능이 없어서 완료일때만 보이게 함 */}
                      {/* {candidate.tester_state === 1 && ( */}
                      {candidate.tester_state >= EXAMSTATE.DONE && (
                        <>
                          <button
                            type="button"
                            className={`status-btn ${
                              candidate.tester_state ? "white" : "black"
                            }`}
                          >
                            중단
                          </button>
                          <button
                            type="button"
                            className={`status-btn ${
                              candidate.tester_state ? "black" : "white"
                            }`}
                          >
                            완료
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                  <td>
                    {/* {candidate.tester_state >= EXAMSTATE.DONE && ( */}
                    {/* // 이게 파란버튼이고 이거 누르면 응시로그 뜨게 */}
                    <button
                      type="button"
                      className="log-modalbtn"
                      onClick={() => {
                        setIsResultCheckModalOpen(true);
                        setResultUserSn(candidate.sn);
                      }}
                    ></button>
                    {/* )} */}
                    {/* {candidate.tester_state < EXAMSTATE.DONE &&
                      candidate.tester_state > 0 && (
                        <button
                          type="button"
                          className="log-modalbtn"
                          disabled
                        ></button>
                      )} */}
                  </td>
                  <td>
                    {candidate.tester_state >= EXAMSTATE.DONE && (
                      <Link to={`/admin/result/${candidate.sn}`}>
                        <button
                          // type="button"
                          className="result-modalbtn"
                        ></button>
                      </Link>
                    )}
                    {candidate.tester_state < EXAMSTATE.DONE && (
                      <button className="result-modalbtn" disabled></button>
                    )}
                  </td>
                  <td>
                    {avgCalculation(
                      Number(candidate.rater_combo_done),
                      Number(candidate.rater_combo_total)
                    )}
                  </td>
                  <td>
                    <button
                      className="trashbtn"
                      onClick={() => {
                        setDeleteUserSn(candidate.sn);
                      }}
                    ></button>
                  </td>
                </tr>
              ))}
              {candidataListData?.data.length === 0 && (
                <tr>
                  <td colSpan={10}>데이터가 없습니다.</td>
                </tr>
              )}
            </Table>
          </div>
        </div>

        {/* <!-- 오픽_관리자_실험실목록_룸클릭_응시자_이름클릭시 --> */}
        <CandidateEditModal selectedCandidate={selectedCandidate} />
        <SendMailModal mailUserSn={mailUserSn} />
        <ResultLogModal
          isOpen={isResultCheckModalOpen}
          setIsOpen={setIsResultCheckModalOpen}
          userSn={resultUserSn}
        ></ResultLogModal>
        <DeleteConfirmModal
          deleteUserSn={deleteUserSn}
          setDeleteUserSn={setDeleteUserSn}
          isCandidate={true}
        />

        {/* <!-- 오픽_관리자_실험실목록_룸클릭_응시자_응시문항 --> */}
        {/* <div
        className="modal fade"
        id="questions"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header flex">
              <p className="sign-top-title" id="staticBackdropLabel">
                OPIC 시험코드
              </p>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body confirm-sec">
              <div className="modal-title">
                <p>응시자: 정현준 (면접코드: sliopic01002)</p>
              </div>
              <div className="modal-cont">
                <p className="questions-table-caption">배정된 면접 문항</p>
                <div className="overflow-scroll height-670">
                  <table className="questions-table">
                    <tbody>
                      <tr>
                        <th>순번</th>
                        <th>문항</th>
                        <th>응답유형</th>
                        <th>준비시간</th>
                        <th>최소응답</th>
                        <th>최대응답</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>
                          <p>질문을 듣고 영어로 답변하세요.</p>
                          <audio controls="controls">
                            <source
                              src="https://www.w3schools.com/html/horse.ogg"
                              type="audio/ogg"
                            />
                          </audio>
                        </td>
                        <td>
                          <img
                            src="../img/admin/icon_video.svg"
                            alt="응답유형"
                          />
                        </td>
                        <td>15초</td>
                        <td>30초</td>
                        <td>180초</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer text-align-right">
              <button
                type="button"
                className="modal-btn modal-close-btn"
                data-bs-dismiss="modal"
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      </div> */}
      </div>
    </div>
  );
};
export default CandidateTab;
